import React, { useContext, useState } from 'react';
import classNames from 'classnames';
import { PuffLoader } from 'react-spinners';
import { AuthContext, Page, Title } from '../../shared';
import { ReactComponent as BeeHeroIcon } from '../../images/BeeHeroIcon.svg';
import ContactUsForm from './ContactUsForm';
import MainHoc from '../MainHoc';
import ContactUsSuccess from './ContactUsSuccess';
import styles from '../Main.module.scss';
import { DEMO_ACCOUNT_URL } from '../../shared/consts';
import { beeheroTitle } from './textConsts';
import useMediaQuery from '../../shared/hooks/useMediaQuery';
import { isMobileQuery } from '../../shared/MediaQuery/mediaQueryUtils';

const ContactUs = (props) => {
    const isMobile = useMediaQuery(isMobileQuery);
    const { userInfo, logout } = useContext(AuthContext);
    const [userEmail, setUserEmail] = useState(false);
    const [loading, setLoading] = useState(false);

    const goToDemo = async (email) => {
        if (userInfo) {
            await logout();
        }
        if (!email) {
            email = userEmail;
        }
        window.location.href = `${DEMO_ACCOUNT_URL}&user_email=${email}`;
    };

    return (
        <MainHoc>
            <div className={classNames({ [styles.content]: !isMobile })}>
                {loading && (
                    <div
                        className={classNames(styles.backdrop, {
                            [styles.full_width]: isMobile
                        })}
                    >
                        <PuffLoader color={'#ffcc2e'} size={100} />
                    </div>
                )}
                <Page noPadding>
                    <Page.Section>
                        <Title flex title={beeheroTitle} svg={BeeHeroIcon} iconSize={userEmail ? 40 : 25} />
                        {userEmail ? (
                            <ContactUsSuccess goToDemo={() => goToDemo()} />
                        ) : (
                            <ContactUsForm setUserEmail={setUserEmail} setLoading={setLoading} goToDemo={goToDemo} />
                        )}
                    </Page.Section>
                </Page>
            </div>
        </MainHoc>
    );
};

export default ContactUs;
